export default __webpack_public_path__ + "static/9001-logo-1edf31e2f59f90b3204abd5d8564a143.png";